import React, {  } from "react";
import { Button, Colors, Display, Sizes } from "Views/Components/Button/Button";
import Modal from "Views/Components/Modal/Modal";

type ESignSignedDocumentProps = {
	name: string;
	base64SignedContract: string;
	onClose: () => void;
}

export const ESignSignedDocument: React.FunctionComponent<ESignSignedDocumentProps> = ({
	name,
	base64SignedContract,
	onClose
}) => {
	const getPdfUrl = () => {
		const encodedString = encodeURIComponent(base64SignedContract);

		const pdfUrl = `data:application/pdf;base64,${encodedString}`;
		return pdfUrl;
	}

	return (
		<Modal
			isOpen
			onRequestClose={onClose}
			label=""
			className="steps"
		>
			<div key="header" className="modal__header">
				<h2 key="header-item" className="modal__title">{name}</h2>
				<Button
					key="header-cancel"
					icon={{ icon: 'close', iconPos: 'icon-only' }}
					display={Display.Solid}
					colors={Colors.Error}
					sizes={Sizes.ExtraLarge}
					onClick={onClose}
					labelVisible={false}
				/>
			</div>
			<iframe
				title="Signed Document"
				src={getPdfUrl()}
				width="100%"
				height="900rem"
			/>
		</Modal>
	)
}